import { createClient, HttpError } from "@/http/lib";
import { systemErrorResponseHandler } from "../handlers/responseError";
import { apiBaseUrl } from "../config";
import { useAlertBasic } from "@/hooks/common";
import { tFactory } from "@/services/i18n";
import { responseHandler } from "../handlers";

const i18nT = tFactory("http.");

export const loginClient = createClient({
  baseURL: apiBaseUrl,
});

export const logoutClient = createClient({
  baseURL: apiBaseUrl,
});

export const touchClient = createClient({
  baseURL: apiBaseUrl,
});

loginClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    systemErrorResponseHandler(error, loginClient.getVueInstance());
    return Promise.reject(new HttpError(error));
  }
);

logoutClient.interceptors.request.use(
  (config) => {
    const app = loginClient.getVueInstance();
    const store = app.config.globalProperties.$store;
    store.dispatch("touch/clearTouchTimer");
    store.commit("globalModal/resetState");

    const token = store.getters["user/token"];

    if (!token) {
      return Promise.reject(config);
    }

    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = token;
    app.config.globalProperties.$store.dispatch("user/clearUser");
    return config;
  },
  (error) => {
    return Promise.reject(new HttpError(error));
  }
);

logoutClient.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => new HttpError(error)
);

touchClient.interceptors.request.use(
  (config) => {
    const { alert } = useAlertBasic();
    const app = touchClient.getVueInstance();
    const router = app?.config.globalProperties.$router;
    const store = app.config.globalProperties.$store;
    const userToken = store.getters["user/token"];
    const expireTime = store.getters["touch/expireTime"];

    if (!userToken || !expireTime || expireTime < Date.now()) {
      store.dispatch("touch/clearTouchTimer");
      store.dispatch("firmware/clearFirmwareUpgradeTimer");
      router.replace({ name: "login" });
      const tips = i18nT("loginExpiration");
      alert(tips);
      return Promise.reject(new Error("Expire."));
    }

    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = userToken;
    return config;
  },
  (error) => Promise.reject(new HttpError(error))
);

touchClient.interceptors.response.use(
  (response) => {
    const app = touchClient.getVueInstance();
    const store = app.config.globalProperties.$store;
    store.dispatch("touch/setTouchTimer");
    return responseHandler(response);
  },
  (error) => {
    const { alert } = useAlertBasic();
    const app = touchClient.getVueInstance();
    const router = app?.config.globalProperties.$router;
    const store = app.config.globalProperties.$store;
    const expireTime = store.getters["touch/expireTime"];

    if (expireTime && expireTime > Date.now()) {
      if (error?.response?.data) {
        router.replace({ name: "login" });
        const tips = i18nT("loginExpiration");
        alert(tips);
        store.dispatch("touch/clearTouchTimer");
      } else {
        store.dispatch("touch/retryTouch");
      }
    }

    return Promise.reject(new HttpError(error));
  }
);
